import _ from "./underscore.js";
import "./toPath.js";
export default function toPath(path) {
  return _.toPath(path);
}
